<template>
  <div class="noteHolder">
  <div class="noteDisplay" v-if="showMeetingDetails">
    <button class="backBtn" @click="goBack()">
      <img src="../../assets/fisher-icon-close.svg" />
      Close
    </button>
    <div class="noteTop">
      <h1>{{meetingDisplay.title}}</h1>
      <p class="noteInfo">
        Meeting Date:
        <span>{{ meetingStartDate() }}</span>

      </p>
      <p class="noteInfo">
        Meeting Time:
        <span>{{ meetingStartTime() }} - {{ meetingEndTime() }}</span>
      </p>
      <p class="noteInfo" >
        Meeting Description:
        <span>{{meetingDisplay.description}}</span>
      </p>
      <p class="noteInfo" >
        Meeting TimeZone:
        <span>{{meetingDisplay.timeZone}}</span>
      </p>
      <p class="noteInfo">
        Platform:
        <span v-if="meetingDisplay.platformId === 1">Zoom meetings</span>
        <span v-if="meetingDisplay.platformId === 2">Other</span>
      </p>
      <p class="noteInfo" v-if="meetingDisplay.meetingLink && meetingDisplay.meetingLink !== ''">
        Event Link:
        <a
          class="meetingLink"
          :href="meetingDisplay.meetingLink"
          target="_blank"
        >Link to meeting</a>
      </p>

      <p class="noteInfo">
        Links:
      </p>
      <div
          class="meetingList"
          v-for="(link, index) in meetingDisplay.links"
          :key="index"
      >
        <img src="../../assets/icon-video-meeting.svg" />
        <span v-if="link.isHost" class="vMeetingTitle" @click="goTo(hostLink)">
          HOST LINK
          <span
              class="vMeetingInfo"
          >{{ buildMeetingLink(link.hash, link.isHost )}}</span>
        </span>
        <span v-if="!link.isHost" class="vMeetingTitle" @click="goTo(visitorLink)">
          PARTICIPANT LINK
          <span
              class="vMeetingInfo"
          >{{ buildMeetingLink(link.hash, link.isHost) }}</span>
        </span>
      </div>



      <div class="buttonHolder">
        <button class="blue" @click="editMeeting(meetingDisplay)">
          <img src="../../assets/fisher-note-edit.svg" /> Edit
        </button>
        <button class="delete" type="button" @click="deleteMeeting(meetingDisplay.meetingId)">Delete</button>
<!--        <button class="blueLine" @click="copyMeetingLink(hostLink, true)">-->
<!--          <img src="../../assets/fisher-icon-copy-blue.svg" /> {{copyButtonText}}-->
<!--        </button>-->
        <button class="blueLine" @click="copyMeetingLink(visitorLink, false)">
          <img src="../../assets/fisher-icon-copy-blue.svg" /> {{copyVisitorButton}}
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import meetingService from "../../services/MeetingService";
import MomentTZ from "moment-timezone";
import store from "../../store";
import Visitors from "@/components/Visitors";
import axios from "axios";

export default {
  components: { Visitors },
  data() {
    return {
      meetingAccessLink: "",
      visitorLink: "",
      hostLink: "",
      copyButtonText: "Copy host link",
      copyVisitorButton: "Copy participant link",
    };
  },
  methods: {
    ...mapMutations([
      "setShowMeetingDetails",
      "toggleModal",
      "setMeetingModalType",
      "setMeetingToEdit",
      "setMeetingDisplay"
    ]),
    ...mapActions(["getMeetingByID", "fetchMeetings"]),
    copyMeetingLink(link, isHost) {
      const el = document.createElement("textarea");
      el.value = `${link}`;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (isHost) {
        this.copyButtonText = "Link copied!";

        setTimeout(() => {
          this.copyButtonText = "Copy host link"
        }, 1500);

      } else {
        this.copyVisitorButton = "Link copied!";
        setTimeout(() => {
          this.copyVisitorButton = "Copy visitor link"
        }, 1500);
      }
    },
    deleteMeeting(id) {
      this.$confirm({
        message: "Are you sure?",
        button: {
          no: "No",
          yes: "Yes",
        },

        callback: (confirm) => {
          if (confirm) {
            meetingService.deleteMeeting(id);
            this.setShowMeetingDetails(false);
          }
        },
      });
    },
    goTo(link) {
      debugger;
      window.open(link, "_blank");
    },
    goBack() {
      this.setShowMeetingDetails(false);
      this.setMeetingDisplay(false);
    },
    editMeeting(meetingDisplay) {
      this.setMeetingToEdit(meetingDisplay);
      this.setMeetingModalType("edit");
      this.toggleModal();
    },
    meetingStartDate() {
      return MomentTZ.utc(this.meetingDisplay.meetingStartTime)
        .tz(this.meetingDisplay.timeZone)
        .format("MMM Do YYYY");
    },
    meetingStartTime() {
      return MomentTZ.utc(this.meetingDisplay.meetingStartTime)
        .tz(this.meetingDisplay.timeZone)
        .format("h:mm a");
    },
    meetingEndTime() {
      return MomentTZ.utc(this.meetingDisplay.meetingEndTime)
        .tz(this.meetingDisplay.timeZone)
        .format("h:mm a");
    },
    buildMeetingLink(hash, isHost) {
      let url = window.location.origin + "/?code=" + hash;
      if (isHost) {
        this.hostLink = url;
      } else {
        this.visitorLink = url;
      }
      return url;
    },
  },
  computed: { ...mapGetters(["meetingDisplay", "showMeetingDetails"]) },
  // mounted() {
  //   setTimeout(() => {
  //     if (this.meetingDisplay.meetingId) {
  //       console.log(this.meetingDisplay.meetingId);
  //       axios
  //         .get(`/api/meetings/visitorlink/${this.meetingDisplay.meetingId}`)
  //         .then((response) => {
  //           console.log("visitorlink", response.data);
  //           this.meetingAccessLink = response.data;
  //         });
  //     }
  //   }, 1000);
  // },
};
</script>

<style lang="scss" scoped src="@/styles/style-noteDisplay.scss">
</style>
<style lang="scss" scoped src="@/styles/style-modal.scss">
</style>
<style lang="scss" scoped>
a.meetingLink {
  color: #1979cc;
  transition: 0.3s;
  &:hover {
    color: #195e99;
  }
}
button.backBtn {
  background-color: transparent;
  border: none;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #1979cc;
  cursor: pointer;
  margin-bottom: 20px;
  outline: none;
  img {
    margin-right: 10px;
  }
}
.buttonHolder {
  margin-top: 50px;
  button {
    height: 45px;
    padding: 0 25px;
    border-radius: 10px;
    margin-right: 15px;

    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    align-items: center;
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    outline: none;
    &.blue {
      background-color: #1979cc;
      border: 1px solid #1979cc;
      color: white;
    }
    &.blueLine {
      background-color: white;
      border: 2px solid #1979cc;
      color: #1979cc;
    }
    &.delete {
      background-color: white;
      border: 2px solid #c4194c;
      color: #c4194c;
    }
    &:hover {
      opacity: 0.85;
    }
    img {
      width: 16px;
      vertical-align: bottom;
    }
  }
}

.addMeeting {
  background: #1979cc;
  border-radius: 5px;
  border: none;
  padding: 15px;
  display: block;
  color: white;
  cursor: pointer;
  outline: none;
  transition: 0.3s;
  margin: 25px 0px;

  img {
    margin: 0 8px 0 0;
    width: 13px;
  }
}

.noteInfoName {
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  color: #949494;
  margin: 10px 0 0;
}

.meetingList {
  cursor: pointer;
  transition: 0.3s;
  margin-top: 15px;
  margin-left: 30px;

  &:hover {
    opacity: 0.8;
  }

  img {
    margin-right: 10px;
  }

  span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;

    color: #1979cc;

    &.vMeetingTitle {
      font-weight: bold;
      text-transform: uppercase;
    }

    &.vMeetingInfo {
      text-transform: initial;
      font-weight: normal;
      display: inline-block;
      margin-left: 10px;
    }
  }
}
</style>
